// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card{border-radius:10px;box-sizing:border-box;padding:20px}", "",{"version":3,"sources":["webpack://./src/common/Card/styles.scss"],"names":[],"mappings":"AAEA,MACE,kBAAA,CACA,qBAAA,CACA,YAAA","sourcesContent":["@import '../../assets/colors';\n\n.card {\n  border-radius: 10px;\n  box-sizing: border-box;\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
